var _rect, _rect2, _path, _path2, _path3, _path4, _circle, _rect3, _rect4, _path5, _path6, _path7, _path8, _circle2, _rect5, _rect6, _path9, _path10, _path11, _path12, _circle3, _rect7, _rect8, _path13, _path14, _path15, _path16, _circle4, _rect9, _rect10, _path17, _path18, _path19, _path20, _circle5, _rect11, _rect12, _path21, _path22, _path23, _path24, _circle6, _path25, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _rect13, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectiveYoga(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 145,
    viewBox: "0 0 269 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73.0479,
    y: 62.0937,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 73.0479 62.0937)",
    fill: "#7CAE78"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73.0479,
    y: 62.0937,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 73.0479 62.0937)",
    stroke: "#DEF0DC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.347 100.292L111.849 93.1828C111.812 92.641 111.376 92.2122 110.834 92.1826L103.114 91.7611",
    stroke: "white",
    strokeWidth: 3.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.114 91.7607L93.0098 101.644",
    stroke: "white",
    strokeWidth: 3.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.329 81.1904L91.6945 82.8431",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.225 92.2225L103.512 82.0166",
    stroke: "white",
    strokeWidth: 7.53846
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23077,
    cy: 3.23077,
    r: 3.23077,
    transform: "matrix(-0.997564 0.0697565 0.0697565 0.997564 106.134 73.1973)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 89.5223,
    y: 10.5576,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 89.5223 10.5576)",
    fill: "#7CAE78"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 89.5223,
    y: 10.5576,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 89.5223 10.5576)",
    stroke: "#DEF0DC",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.148 49.4352L127.775 42.3188C127.747 41.7764 127.319 41.3401 126.777 41.301L119.065 40.7448",
    stroke: "white",
    strokeWidth: 3.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.065 40.7451L108.79 50.45",
    stroke: "white",
    strokeWidth: 3.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.464 30.3896L107.804 31.6296",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.169 41.2265L119.634 31.0098",
    stroke: "white",
    strokeWidth: 7.53846
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23077,
    cy: 3.23077,
    r: 3.23077,
    transform: "matrix(-0.99863 0.052336 0.052336 0.99863 122.409 22.2373)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 130.094,
    y: 61.0479,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 130.094 61.0479)",
    fill: "#7CAE78"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130.094,
    y: 61.0479,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 130.094 61.0479)",
    stroke: "#DEF0DC",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.694 104.343L164.191 97.2346C164.229 96.6928 163.857 96.2076 163.325 96.1028L155.738 94.6109",
    stroke: "white",
    strokeWidth: 3.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.738 94.6104L144.356 102.991",
    stroke: "white",
    strokeWidth: 3.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M169.306 85.8438L145.671 84.1911",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M156.775 95.2234L157.488 85.0176",
    stroke: "white",
    strokeWidth: 7.53846
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23077,
    cy: 3.23077,
    r: 3.23077,
    transform: "matrix(-0.997564 -0.0697565 -0.0697565 0.997564 161.312 76.6484)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 170.722,
    y: 35.7631,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 170.722 35.7631)",
    fill: "#7CAE78"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 170.722,
    y: 35.7631,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 170.722 35.7631)",
    stroke: "#DEF0DC",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.985 74.9534L197.835 68.9046C197.9 68.4436 197.611 68.0065 197.162 67.8851L190.764 66.1559",
    stroke: "white",
    strokeWidth: 2.76923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M190.764 66.1562L180.531 72.6414",
    stroke: "white",
    strokeWidth: 2.76923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M202.89 59.4707L182.78 56.6444",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M191.614 66.7415L192.834 58.0576",
    stroke: "white",
    strokeWidth: 6.46154
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.76923,
    cy: 2.76923,
    r: 2.76923,
    transform: "matrix(-0.990268 -0.139173 -0.139173 0.990268 196.604 51.1309)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 141.218,
    y: 1.39592,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(9 141.218 1.39592)",
    fill: "#7CAE78"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 141.218,
    y: 1.39592,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(9 141.218 1.39592)",
    stroke: "#DEF0DC",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M166.793 41.0386L167.749 35.0056C167.821 34.5458 167.541 34.1037 167.093 33.9745L160.727 32.1339",
    stroke: "white",
    strokeWidth: 2.76923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M160.727 32.1338L150.382 38.4393",
    stroke: "white",
    strokeWidth: 2.76923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M172.967 25.6611L152.909 22.4843",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M161.566 32.7345L162.938 24.0732",
    stroke: "white",
    strokeWidth: 6.46154
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.76923,
    cy: 2.76923,
    r: 2.76923,
    transform: "matrix(-0.987688 -0.156434 -0.156434 0.987688 166.829 17.2119)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 45.9157,
    y: 29.2736,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-5 45.9157 29.2736)",
    fill: "#7CAE78"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 45.9157,
    y: 29.2736,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-5 45.9157 29.2736)",
    stroke: "#DEF0DC",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3215 61.5516L79.7892 55.4667C79.7486 55.0029 79.369 54.642 78.9038 54.6247L72.2812 54.379",
    stroke: "white",
    strokeWidth: 2.76923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2812 54.3789L63.7694 62.9997",
    stroke: "white",
    strokeWidth: 2.76923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5918 45.1377L62.3614 46.9076",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2409 54.7583L72.4766 46.0225",
    stroke: "white",
    strokeWidth: 6.46154
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.76923,
    cy: 2.76923,
    r: 2.76923,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 74.5918 38.4248)",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 87C55 85.8954 55.8954 85 57 85H77.2654C78.2607 85 79.1046 85.7319 79.2453 86.7172L82.7547 111.283C82.8954 112.268 83.7393 113 84.7346 113H185.265C186.261 113 187.105 112.268 187.245 111.283L190.755 86.7172C190.895 85.7319 191.739 85 192.735 85H213C214.105 85 215 85.8954 215 87V113V139C215 140.105 214.105 141 213 141H183H87H57C55.8954 141 55 140.105 55 139V113V87Z",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 115.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 46.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.5,
    cy: 41.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 3.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.5,
    cy: 113.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 27 145)",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M214 23.5L236 19",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M233.5 69.5L249.5 72.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18.5L34 23.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M36 75.5L18.5 80",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveYoga);
export default __webpack_public_path__ + "static/media/collective-yoga.eb711a89052bf88349f4798a3583fc2f.svg";
export { ForwardRef as ReactComponent };